import { Typography } from "components/common/Typography";
import React from "react";
import reactStringReplace from "react-string-replace";

import { StyledLink } from "./styled";

type WidthLinkTextProps = {
  text?: string;
  textColor?: string;
  fontSize?: "small" | "medium" | "large";
};

export const WidthLinkText: React.FC<WidthLinkTextProps> = ({
  text,
  textColor,
  fontSize,
}) => {
  const splitByUrl = reactStringReplace(
    text,
    /(https?:\/\/\S+)/g,
    (match, i) => (
      <StyledLink
        key={match + i}
        href={match}
        target="_blank"
        rel="noopener noreferrer"
        fontSize={fontSize}
      >
        {match}
      </StyledLink>
    )
  );

  return (
    <>
      {splitByUrl.map((piece, index) => {
        if (typeof piece === "string") {
          return (
            <Typography
              key={index}
              text={piece}
              fontSize={fontSize}
              color={textColor}
              lineHeight={
                window.matchMedia("(min-width:600px)").matches ? "1.5" : "1.2"
              }
            />
          );
        } else {
          return piece;
        }
      })}
    </>
  );
};
